/**
 * The eight reports — the one registry.
 *
 * This list used to exist in four hand-synced places: the page registry in
 * `src/routes/Reports.tsx`, the slug+title repeated inside each report
 * component, the Convex function names in `tools/permcheck.mjs`, and the slugs
 * in `tools/demo.mjs`. Both tools carried a comment admitting they were "kept
 * in step by hand". The failure mode was silent: report #9 gets added, neither
 * harness probes it, and both report green on a report nobody checked.
 *
 * It is a `.mjs` file (with `reports.d.mts` beside it for tsc) because the
 * tools run under plain Node, which cannot import the `.ts` files in this
 * directory. Vite and tsc resolve it fine from `@shared/reports.mjs`.
 *
 * `fn` is the Convex function path `permcheck` probes over the wire. `title`
 * is what the report's error boundary shows if its query throws — one string,
 * so the error card can never name a different report than the section it
 * replaces.
 */
export const REPORTS = [
  { slug: "outstanding-requests", label: "Outstanding", title: "Outstanding requests", fn: "reports/outstandingRequests:data" },
  { slug: "back-ordered", label: "Back-order", title: "Back-ordered items", fn: "reports/backOrdered:data" },
  { slug: "not-received", label: "Not received", title: "Dispatched, not received", fn: "reports/notReceived:data" },
  { slug: "low-stock", label: "Low stock", title: "Warehouse low stock", fn: "reports/lowStock:data" },
  { slug: "inventory-value", label: "Inventory $", title: "Warehouse inventory value", fn: "reports/inventoryValue:data" },
  { slug: "clinic-monthly-cost", label: "Per clinic", title: "Monthly supply cost per clinic", fn: "reports/clinicMonthlyCost:data" },
  { slug: "vendor-spending", label: "Vendors", title: "Vendor spending", fn: "reports/vendorSpending:data" },
  { slug: "top-items", label: "Most ordered", title: "Most-ordered items", fn: "reports/topItems:data" },
];
